import { Menu } from "@mui/material"
import React from "react"

type InnerMenuWrapperTypes = {
    anchorEl: HTMLElement | null;
    open: boolean;
    height: number;
    handleClose: () => void;
    children: React.ReactNode;
}

export const InnerMenuWrapper: React.FC<InnerMenuWrapperTypes> = ({
    anchorEl,
    handleClose,
    height,
    open,
    children
}) => {
    return (
        <Menu
            id="long-menu"
            MenuListProps={{
            'aria-labelledby': 'long-button',
                style: {
                    paddingBottom: 0,
                    paddingTop: 0
                }
            }}
            anchorEl={anchorEl}
            open={open}
            PaperProps={{
                style: {
                    maxHeight: height * 4.5,
                    width: '208px',
                    borderTopRightRadius: 0,  
                    borderBottomRightRadius: 0
                }
            }}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            {children}
        </Menu>
    )
}